import React from 'react';
import { Form, Row, Col, Button } from "antd";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import PropTypes from "prop-types";
import { DISBURSAL_CONTROLS_FIELDS } from "constants/form-fields";
import { MpaFormsFooter } from '../../modules/companies/modules/mpa-form-footer';

class DisbursalControlForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);

    onSave = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if(!err){
                this.props.updateDetail(this.props.form.getFieldsValue())
            }
        }); 
    }

    onApprove = () => {
        this.props.form.validateFields((err, values) => {
            if(!err){
                this.props.approveDetails()
            }
        }); 
    }

    render() {
        return (
            <div className={"d-flex flex-row justify-content-space-between flex-wrap w-100 form"}>
                <Row>
                    <Form onSubmit={this.onSave}>

                        <Row>
                            {DISBURSAL_CONTROLS_FIELDS.map((field, fieldName) => {
                                field.disabled = this.props.disableFields;
                                return <Col span="8">{this.fieldGenerator(
                                    fieldName,
                                    field,
                                    this.getValidateStatus(fieldName)
                                )()}</Col>
                            }).toList()}

                        </Row>
                        <Row>
                            <MpaFormsFooter
                                disableFields={this.props.disableFields}
                                approveDisabled={this.props.approveDisabled}
                                onApprove={this.onApprove}
                            />
                        </Row>
                    </Form>

                </Row>
            </div>
        );
    }
}

DisbursalControlForm.propTypes = {
    updateDetail: PropTypes.func,
    approveDetails: PropTypes.func,
    approveDisabled: PropTypes.bool,
    disableFields: PropTypes.bool
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
            values
                .map((value, key) => {
                    return Form.createFormField({
                        value
                    });
                }).toJS();
    },
    onValuesChange: (props, changedValues, values) => {
    }
})(DisbursalControlForm);